import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Bars = styled.div`
  width: 25px;
  height: 5px;
  background-color: ${props => props.theme.carvana[props.color]};
  margin: 4px 0;
`;
const BarWrapper = styled.div`
  cursor: pointer;
`;

const BarsIcon = ({ onClick, color }) => (
  <BarWrapper onClick={onClick}>
    <Bars color={color} />
    <Bars color={color} />
    <Bars color={color} />
  </BarWrapper>
);

BarsIcon.propTypes = {
  onClick: PropTypes.func,
  color: PropTypes.string
};

BarsIcon.defaultProps = {
  onClick: null,
  color: 'blue'
};

export default BarsIcon;
